import { useDispatch, useSelector, type TypedUseSelectorHook } from "react-redux";
import { useEffect, useRef } from "react";

// Type
import type { RootStateType, AppDispatchType } from "./index";

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch: () => AppDispatchType = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootStateType> = useSelector;

export const useStartTyping = (inputRef: HTMLInputElement | null, doneCallback: Function, maxTime: number, minTime: number, betTime: number, delayCallback?: boolean) => {
  // Max timer
  const maxTimeout = useRef<number | ReturnType<typeof setTimeout>>(undefined);

  // Construct typingTimer
  const typingTimer = useRef<number | ReturnType<typeof setInterval>>(undefined);
  const delayCallbackRef = useRef(delayCallback);

  const preDoneCb = () => {
    if (delayCallbackRef.current) return;

    clearTimeout(maxTimeout.current);
    doneCallback();
  };

  useEffect(() => {
    delayCallbackRef.current = delayCallback;

    if (inputRef) {
      if (!delayCallbackRef.current) typingTimer.current = setTimeout(preDoneCb, betTime);
    }
  }, [delayCallback, inputRef]);

  useEffect(() => {
    if (inputRef) {
      clearTimeout(maxTimeout.current);
      clearTimeout(typingTimer.current);

      maxTimeout.current = setTimeout(doneCallback, maxTime);
      typingTimer.current = setTimeout(preDoneCb, minTime);

      inputRef?.addEventListener("keyup", () => {
        clearTimeout(typingTimer.current);

        typingTimer.current = setTimeout(preDoneCb, betTime);
      });

      inputRef?.addEventListener("keydown", () => {
        clearTimeout(typingTimer.current);
      });
    } else {
      clearTimeout(maxTimeout.current);
      clearTimeout(typingTimer.current);
    }

    return () => {
      clearTimeout(maxTimeout.current);
      clearTimeout(typingTimer.current);
    };
  }, [inputRef]);
};
